/**
 * Event Mapper
 *
 * Maps events from Payment Checkout UI to Agent Progress UI timeline events
 */

import type { TimelineEventType } from '../types/chat-timeline.types';

/**
 * Field types from Payment Checkout UI (FIELD_COMPLETED SSE event).
 * LINK_OPENED arrives as timeline_event, not FIELD_COMPLETED — handled by onTimelineEvent.
 */
export type CheckoutUIFieldType =
  | 'CARD_NUMBER'
  | 'EXPIRY'
  | 'CVV'
  | 'CARDHOLDER_NAME';

/**
 * Map Checkout UI field type to Agent UI timeline event type
 */
export function mapFieldToTimelineEvent(
  field: CheckoutUIFieldType
): TimelineEventType {
  const mapping: Record<CheckoutUIFieldType, TimelineEventType> = {
    CARD_NUMBER: 'CARD_NUMBER_ENTERED',
    CARDHOLDER_NAME: 'CARDHOLDER_NAME_ENTERED',
    EXPIRY: 'EXPIRY_ENTERED',
    CVV: 'CVC_ENTERED',
  };

  return mapping[field];
}

/**
 * Map field to human-readable status text
 */
export function getFieldStatusText(field: CheckoutUIFieldType): string {
  const statusMap: Record<CheckoutUIFieldType, string> = {
    CARD_NUMBER: 'Card number entered',
    CARDHOLDER_NAME: 'Name on card entered',
    EXPIRY: 'Expiration date entered',
    CVV: 'CVC entered',
  };

  return statusMap[field];
}
